<template>
  <PipelineShowInfoCard
    @tab-changed="handleTabChange"
    :isMobile="isMobile"
    :data="data"
  ></PipelineShowInfoCard>

  <PipelineShowCandidatesTable
    v-if="!isMobile || activeTab === 2"
    :data="data"
    :options="data.options.jobfit_status_all_options"
    :isLoadingShowMore="isLoadingShowMore"
    :isLoadingCandidates="isLoadingCandidates"
    @loadCandidates="handleLoadCandidates"
  >
  </PipelineShowCandidatesTable>
</template>

<script setup>
  import axios from 'axios';

  import { nextTick, onMounted, onUnmounted, ref } from 'vue';
  import { useToast } from 'vue-toastification';

  import PipelineShowCandidatesTable from './components/PipelineShowCandidatesTable/PipelineShowCandidatesTable.vue';
  import PipelineShowInfoCard from './components/PipelineShowInfoCard/PipelineShowInfoCard.vue';
  import { __ } from '@/helpers';

  const props = defineProps({
    data: {
      type: Object,
      required: true
    }
  });

  const activeTab = ref(1);
  const data = ref(props.data || []);
  const isLoadingShowMore = ref(false);
  const isLoadingCandidates = ref(false);
  const toast = useToast();

  const isMobile = ref(
    // 640 is the sm: tailwind value
    typeof window !== 'undefined' ? window.innerWidth < 640 : false
  );

  const handleTabChange = (tab) => {
    activeTab.value = tab;
  };

  const handleResize = () => {
    isMobile.value = window.innerWidth < 640;
  };

  onMounted(() => {
    isMobile.value = window.innerWidth < 640;
    window.addEventListener('resize', handleResize);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
  });

  onMounted(async () => {
    await nextTick(); // Wait for DOM updates

    const storedMessage = sessionStorage.getItem('toast_message');
    if (storedMessage) {
      const { type, message } = JSON.parse(storedMessage);
      toast[type](message);
      sessionStorage.removeItem('toast_message');
    }
  });

  const handleLoadCandidates = async (eventData) => {
    if (eventData.reset) {
      isLoadingCandidates.value = true;
    } else {
      isLoadingShowMore.value = true;
    }

    try {
      const response = await axios.get(
        route(
          'redesign.company.pipelines.candidates.load',
          eventData.pipelineId
        ),
        {
          params: { page: eventData.page, search_query: eventData.search_query }
        }
      );

      if (eventData.reset) {
        data.value.pipeline.candidates = response.data.data.pipeline.candidates;
      } else {
        data.value.pipeline.candidates.data.push(
          ...response.data.data.pipeline.candidates.data
        );
        data.value.pipeline.candidates.last_page =
          response.data.data.pipeline.candidates.last_page;
        data.value.pipeline.candidates.current_page =
          response.data.data.pipeline.candidates.current_page;
      }
    } catch (error) {
      toast.error(error.response?.data?.message || __('Something went wrong'));
    } finally {
      isLoadingShowMore.value = false;
      isLoadingCandidates.value = false;
    }
  };
</script>
